import { formatDistanceToNow, parseISO } from 'date-fns';

/**
 * Safely formats a date-like value as relative time (e.g., "3 minutes ago").
 * Accepts Date, ISO string, or timestamp number. Falls back to "Recently".
 */
export const formatRelativeSafe = (input: unknown): string => {
  let date: Date | null = null;

  try {
    if (input instanceof Date) {
      date = input;
    } else if (typeof input === 'number') {
      // Treat as epoch ms
      date = new Date(input);
    } else if (typeof input === 'string') {
      // Prefer parseISO, but fallback to Date constructor for non-ISO strings
      const parsed = parseISO(input);
      date = isNaN(parsed.getTime()) ? new Date(input) : parsed;
    }
  } catch {
    date = null;
  }

  if (!date || isNaN(date.getTime())) return 'Recently';

  try {
    return formatDistanceToNow(date, { addSuffix: true });
  } catch {
    return 'Recently';
  }
};
